import React from 'react';
import { WebUrlData } from '@base-configs';
import { Navigate } from 'react-router-dom';

export function CrmFeature() {
  return <Navigate to={WebUrlData.crm_board} replace />;
}
